<template>
  <div id="panel-product-optional-info">
    <div>
      <span><strong>Product Information</strong></span>
      <v-textarea
        dense
        outlined
        rows="8"
        class="mt-2"
        v-model="product.details"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :disabled="viewModeOnly"
        :rules="[
          (value) =>
            textAreaLengthRule(
              value,
              fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA
            )
        ]"
      ></v-textarea>
    </div>

    <div v-if="!isServicesTypeProduct">
      <span>
        <strong>Country of Origin</strong>
        <v-icon
          class="i-tooltip-color pl-1 pb-1"
          small
          v-tooltip="'Cannot be edited if product is or has been Live'"
        >
          mdi-help-circle-outline
        </v-icon>
      </span>
      <v-text-field
        dense
        outlined
        class="py-2"
        v-model="product.countryOfOrigin"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :disabled="
          (!newProduct && originalProduct.countryOfOrigin !== '') ||
          viewModeOnly
        "
      ></v-text-field>
    </div>

    <div v-if="isLiquorTypeProduct">
      <span>
        <strong>State of Origin</strong>
      </span>
      <v-text-field
        dense
        outlined
        class="py-2"
        v-model="product.liquorInformation.stateOfOrigin"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :disabled="viewModeOnly"
      ></v-text-field>
    </div>

    <div v-if="isLiquorTypeProduct">
      <span>
        <strong>Region of Origin</strong>
      </span>
      <v-text-field
        dense
        outlined
        class="py-2"
        v-model="product.liquorInformation.regionOfOrigin"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_FIELD"
        :disabled="viewModeOnly"
      ></v-text-field>
    </div>

    <div v-if="isLiquorTypeProduct">
      <span>
        <strong>Specifications</strong>
      </span>
      <v-row class="mt-2 pt-2">
        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Varietal"
            v-model="product.liquorInformation.varietal"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Type"
            v-model="product.liquorInformation.type"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Style"
            v-model="product.liquorInformation.style"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Current Vintage"
            v-model="product.liquorInformation.vintage"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Closure"
            v-model="product.liquorInformation.closureType"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <i-numeric-field
            :counter="5"
            dense
            :disabled="viewModeOnly"
            label="Alcohol Volume (%)"
            :min="0"
            :max="100"
            :precision="1"
            outlined
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            v-model="product.liquorInformation.alcoholVolume"
          ></i-numeric-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <i-numeric-field
            :counter="5"
            dense
            :disabled="viewModeOnly"
            label="Standard Drinks"
            :min="0"
            :max="100"
            :precision="1"
            outlined
            v-model="product.liquorInformation.standardDrinks"
          ></i-numeric-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Wine Body"
            v-model="product.liquorInformation.wineBody"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Wine Maker"
            v-model="product.liquorInformation.wineMaker"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Wine Sweetness"
            v-model="product.liquorInformation.wineSweetness"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Brewery"
            v-model="product.liquorInformation.brewery"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>

        <v-col class="p-liquor-specs-col" cols="12" md="6">
          <v-text-field
            dense
            outlined
            label="Bottled In"
            v-model="product.liquorInformation.bottledIn"
            :counter="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :maxlength="fieldsRulesValues.MAX_CHARACTERS_LIQUOR_SPECIFICATIONS"
            :disabled="viewModeOnly"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <div v-if="!isServicesTypeProduct">
      <span>
        <strong>Ingredients</strong>
      </span>
      <v-textarea
        dense
        outlined
        rows="8"
        class="mt-2"
        v-model="product.ingredients"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :disabled="viewModeOnly"
        :rules="[
          (value) =>
            textAreaLengthRule(
              value,
              fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA
            )
        ]"
      ></v-textarea>
    </div>

    <div v-if="isGroceryTypeProduct">
      <span>
        <strong>Dietary Information</strong>
      </span>
      <div class="d-flex justify-space-around my-4">
        <v-row no-gutters>
          <v-col
            cols="4"
            v-for="(value, key) in product.dietaryInformation"
            :key="key"
          >
            <v-checkbox
              class="ma-0 pa-0"
              v-model="value.value"
              :disabled="viewModeOnly"
              :label="value.displayName"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </div>
    </div>

    <div v-if="!isServicesTypeProduct">
      <span>
        <strong>Allergens / Warnings</strong>
      </span>
      <v-textarea
        dense
        outlined
        rows="8"
        class="mt-2"
        v-model="product.allergens"
        :counter="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :maxlength="fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA"
        :disabled="viewModeOnly"
        :rules="[
          (value) =>
            textAreaLengthRule(
              value,
              fieldsRulesValues.MAX_CHARACTERS_TEXT_AREA
            )
        ]"
      ></v-textarea>
    </div>

    <div>
      <span><strong>Product keywords (Maximum 5)</strong></span>
      <v-icon
        class="i-tooltip-color pl-1 pb-1"
        small
        v-tooltip="'Type a word & press ENTER to add keyword'"
      >
        mdi-help-circle-outline
      </v-icon>

      <i-premium-feature
        class="mt-2"
        v-if="featureSubscriptionEnabled && !hasPremiumSubscription"
        text="Product Keywords is a Premium feature"
      />

      <v-combobox
        class="mt-2"
        clearable
        dense
        attach
        :disabled="
          (featureSubscriptionEnabled && !hasPremiumSubscription) ||
          viewModeOnly
        "
        :items="product.supplierKeywords"
        multiple
        outlined
        :rules="[
          (value) => maxKeywordsRule(value, fieldsRulesValues.MAX_KEYWORDS)
        ]"
        small-chips
        v-model="product.supplierKeywords"
      >
        <template v-slot:selection="{ item }">
          <v-chip small>
            {{ item }}
          </v-chip>
        </template>
      </v-combobox>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FieldValidators from '@/utils/FieldValidators'
import iPremiumFeature from '@/components/PremiumFeature'
import iNumericField from '@/components/NumericField'

export default {
  components: {
    iNumericField,
    iPremiumFeature
  },

  props: {
    fieldsRulesValues: {
      type: Object,
      default: () => {}
    },
    isGroceryTypeProduct: {
      type: Boolean,
      default: true
    },
    newProduct: {
      type: Boolean,
      default: true
    },
    originalProduct: {
      type: Object,
      default: () => {}
    },
    product: {
      type: Object,
      default: () => {}
    },
    viewModeOnly: {
      type: Boolean,
      default: true
    },

    isLiquorTypeProduct: {
      type: Boolean,
      default: false
    },

    isServicesTypeProduct: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    ...FieldValidators
  }),

  computed: {
    ...mapGetters('profile', ['hasPremiumSubscription']),
    ...mapGetters('tenant', ['featureSubscriptionEnabled'])
  }
}
</script>

<style lang="scss" scoped>
#panel-product-optional-info {
  .p-liquor-specs-col {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
